module.exports = __webpack_public_path__ + "static/media/animal-fat.ba31092d.svg";